import React, { useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSession } from '../../Utils/SessionContext';

const Navigation = ({ title, showBackButton = true }) => {
  const { user, logout } = useSession();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuRef = useRef(null);
  
  const handleMouseEnter = () => {
    setMenuOpen(true);
  };
  
  const handleMouseLeave = () => {
    setMenuOpen(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-40 flex justify-between items-center p-4 bg-white rounded-b-lg shadow mb-6 mx-5">
      <div className="flex items-center">
        {showBackButton && (
          <button 
            onClick={() => navigate(-1)} 
            className="mr-4 px-3 py-1 bg-gray-200 text-gray-700 font-semibold rounded hover:bg-gray-300 transition-colors"
          >
            Back
          </button>
        )}
        <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
      </div>
      
      <div className="flex items-center space-x-3">
        {/* Superadmin Badge */}
        {user?.role === 'Superadmin' && (
          <span className="px-3 py-1 bg-red-500 text-white text-xs font-semibold rounded-full">
            Superadmin
          </span>
        )}
        
        <div 
          className="relative" 
          ref={menuRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button 
            className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-t hover:bg-blue-600 transition-colors flex items-center"
          >
            Menu
            <svg 
              className={`ml-2 w-4 h-4 transition-transform ${menuOpen ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
        
        <div 
          className={`absolute right-0 w-48 bg-white rounded-b-md shadow-lg py-1 z-50 transition-opacity duration-200 ease-in-out ${
            menuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          }`}
        >
            <Link 
              to="/dashboard" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Dashboard
            </Link>
            <Link 
              to="/jobs" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Jobs
            </Link>
            <Link 
              to="/talent" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Talent
            </Link>
            <Link 
              to="/evaluations" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Evaluation Templates
            </Link>
            <Link 
              to="/documentation" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Documentation
            </Link>
            <Link 
              to="/settings" 
              className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Settings
            </Link>
            {user?.role === 'Superadmin' && (
              <>
                <Link 
                  to="/prompts" 
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                >
                  Prompts
                </Link>
                <Link 
                  to="/library" 
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                >
                  Library
                </Link>
              </>
            )}
            <div className="border-t border-gray-100 my-1"></div>
            <button 
              onClick={handleLogout} 
              className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
            >
              Logout
            </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
